<template>
  <center
    style="padding-left: 50px;padding-right:50px; padding-top:10px;padding-bottom:10px;"    
  >
    <v-btn
      block
      style="height: 50px;"
      :color="BGColorSecundary"
      :style="{ 'color': ColorSecundary}" 
      dark
      @click="handleGoTo"
    >
      {{ text }}
    </v-btn>
    <external-link
      v-if="externalLink"
      :item="externalLink"
      :locale="locale"
      :showDialog="showExternalLink"
      :onClose="handleCloseExternalLink"
      :bgColor="BGColor"
    />
  </center>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import ExternalLink from '../../../totem/totemMainMenu/ExternalLink'
  export default {
    components: {
      ExternalLink,
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      showExternalLink: false,
      externalLink: null,
    }),
    computed: {
      ...mapState('app',['BGColor', 'locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'BGColorSecundary', 'ColorSecundary']),
      text () {
        return this.data.LinkExternalName ? utils.getTranslation (this.data.LinkExternalName, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      isTotem () {
        return this.$route.path.indexOf('/totem') >= 0 || utils.isTotem()
      },
    },
    methods: {
      handleCloseExternalLink () {
        this.showExternalLink = false
      },
      handleGoTo () {
        if (this.isTotem) {
          this.externalLink = {
            externalLink: this.data.LinkExternal
          }
          this.showExternalLink = true
        }else if (!this.isSimulation) {
          let  url = utils.getTranslation (this.data.LinkExternal, this.locale)

          // ini showroom
          const actualUrl = window.location.href
          if (actualUrl.indexOf('?') < 0) url += '?'
          if (actualUrl.indexOf('fm=true') > 0) url += '&fm=true'
          if (actualUrl.indexOf('fl=true') > 0) url += '&fl=true'
          // end showroom
          if (this.data.LinkExternalNewTab)
            window.open(
              url,
              '_blank' // <- This is what makes it open in a new window.
            )
          else window.location.href = url
        }        
      }
    }
  }
</script>
